import { styled } from '@mui/material/styles';
import { Paper, IconButton, Box } from '@mui/material';

export const WordTile = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  width: '240px',
  [theme.breakpoints.down('sm')]: {
    width: '85vw',
    maxWidth: '240px',
    padding: theme.spacing(1.5),
  },
  marginBottom: 0,
  cursor: 'pointer',
  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
  position: 'relative',
  borderRadius: '8px',
  border: '3px solid black',
  backgroundColor: '#FFE4A3',
  boxShadow: '6px 6px 0px 0px rgba(0,0,0,1)',
  transform: 'translate(-3px, -3px)',
  '&:hover': {
    transform: 'translate(0px, 0px)',
    boxShadow: '3px 3px 0px 0px rgba(0,0,0,1)',
  },
  '&:hover .delete-button, &:active .delete-button, &:hover .cancel-button, &:active .cancel-button': {
    display: 'flex',
  },
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
}));

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: -12,
  right: -12,
  display: 'none',
  backgroundColor: '#FF4911',
  padding: 6,
  width: '32px',
  height: '32px',
  borderRadius: '4px',
  border: '3px solid black',
  boxShadow: '3px 3px 0px 0px rgba(0,0,0,1)',
  transform: 'translate(-2px, -2px)',
  '&:hover': {
    backgroundColor: '#FF4911',
    transform: 'translate(0px, 0px)',
    boxShadow: '1px 1px 0px 0px rgba(0,0,0,1)',
  },
  '& .delete-x': {
    color: 'black',
    fontFamily: '"Public Sans", Arial, sans-serif',
    fontWeight: 900,
    fontSize: '20px',
    lineHeight: 1,
    marginTop: '-2px'
  },
  '@media (hover: none)': {
    '&:active': {
      display: 'flex',
    }
  },
}));

export const CancelButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: -12,
  right: -12,
  display: 'none',
  backgroundColor: '#FF4911',
  padding: 6,
  width: '32px',
  height: '32px',
  borderRadius: '4px',
  border: '3px solid black',
  boxShadow: '3px 3px 0px 0px rgba(0,0,0,1)',
  transform: 'translate(-2px, -2px)',
  zIndex: 10,
  '&:hover': {
    backgroundColor: '#FF4911',
    transform: 'translate(0px, 0px)',
    boxShadow: '1px 1px 0px 0px rgba(0,0,0,1)',
  },
  '& .MuiSvgIcon-root': {
    color: 'black',
    fontSize: '20px',
  },
  '@media (hover: none)': {
    '&:active': {
      display: 'flex',
    }
  },
}));

export const ArrowContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '48px',
  [theme.breakpoints.down('sm')]: {
    height: '36px',
  },
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0',
  '&::before': {
    content: '""',
    position: 'absolute',
    bottom: theme.spacing(1),
    width: 0,
    height: 0,
    borderLeft: '12px solid transparent',
    borderRight: '12px solid transparent',
    borderTop: '16px solid currentColor',
    [theme.breakpoints.down('sm')]: {
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: '14px solid currentColor',
    },
  }
})); 